import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { connect, Field, getIn } from 'formik';
import { ErrorText, InputWrapper, Label, inputStyle } from '../sharedStyles';
import InputMask from 'react-input-mask';

export const StyledInput = styled(Field)`
  ${inputStyle}
`;

const CustomInputMask = props => (
  <InputMask {...props}>{inputProps => <StyledInput {...inputProps} />}</InputMask>
);

function MaskedInput({ formik, label, name, placeholder, ...rest }) {
  const error = getIn(formik.errors, name);
  const touched = getIn(formik.touched, name);
  const hasError = touched && error;
  return (
    <InputWrapper>
      <Label htmlFor={name}>{label}</Label>
      <CustomInputMask
        $hasError={hasError}
        id={name}
        mask="99/99/9999"
        name={name}
        placeholder={placeholder ? placeholder : label}
        {...rest}
      />
      {hasError && <ErrorText children={error} />}
    </InputWrapper>
  );
}

MaskedInput.propTypes = {
  formik: PropTypes.shape({
    errors: PropTypes.any.isRequired,
    touched: PropTypes.any.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

MaskedInput.defaultProps = {
  placeholder: null,
};

export default connect(MaskedInput);
